export const wellnow = {
	PAGE_THEME_ENABLED: false,
};
